if (window.customElements && !customElements.get('featured-collection-tabs')) {
  customElements.define(
    'featured-collection-tabs',
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.contentContainer = null;
      }

      connectedCallback() {
        this.contentContainer = this.querySelector('.collection-tabs__content');
        this.tabs = this.querySelectorAll('.collection-tabs__tab');
        this.tabs.forEach(function initializeTab(tab) {
          // Ensure initial aria-selected is set based on active class
          tab.setAttribute('aria-selected', tab.classList.contains('active'));
          tab.addEventListener('click', this.onTabChange.bind(this));
        }.bind(this));

        this.tabPanels = this.querySelectorAll('.collection-tabs__panel');
      }
      disconnectedCallback() {
        this.tabs.forEach(function removeTab(tab) {
          tab.removeEventListener('click', this.onTabChange.bind(this));
        }.bind(this));
      }

      onTabChange(event) {
        var index = event.currentTarget.getAttribute('data-index');

        // Update tabs
        this.tabs.forEach(function updateTab(tab) {
          tab.classList.remove('active');
          tab.setAttribute('aria-selected', 'false');
        });

        event.currentTarget.classList.add('active');
        event.currentTarget.setAttribute('aria-selected', 'true');

        // Update panels and animate height
        this.tabPanels.forEach(function updatePanel(panel) {
          panel.classList.remove('active');
        });

        const targetPanel = this.tabPanels[index];
        targetPanel.classList.add('active');

        // Force a repaint to ensure the panel is visible for height calculation
        targetPanel.style.position = 'relative';
        const height = targetPanel.offsetHeight;
        targetPanel.style.position = '';

        // Set the container height
        this.contentContainer.style.setProperty('--content-height', height + 'px');
      }
    }
  )
}
